export function getDemandText(demandCode) {
    switch (demandCode) {
      case 1:
        return 'In Demand';
      case 2:
        return 'Not In Demand';
      case 3:
        return 'Balanced';
      default:
        return 'N/A';
    }
  }
  
  // or, as a dictionary if you prefer:
  export const demandTextMap = {
    1: 'In Demand',
    2: 'Not In Demand',
    3: 'Balanced',
    null: 'N/A',
  };